import { FC } from "react"
import { useLocation } from "react-router-dom"

import { selectCompanyAddress, selectCompanyPhone } from "@/entities/options"

import { useAppSelector } from "@/shared/lib/store"
import { useMediaQuery } from "@/shared/lib/media"

import { Button, Text } from "@mantine/core"
import { ContactModal } from "@/shared/ui"
import { SettingsButton } from "../SettingsButton"
import { Anchor } from "@/shared/ui/Anchor"

import PhoneIcon from "@/shared/assets/icons/phone-line.svg?react"
import MapPinIcon from "@/shared/assets/icons/map-pin-2-line.svg?react"
import classes from "./styles.module.scss"

interface HeaderInfoProps {
	isOpen: boolean
	openSidebar: () => void
}

export const HeaderInfo: FC<HeaderInfoProps> = ({ openSidebar, isOpen }) => {
	const companyAddress = useAppSelector(selectCompanyAddress)
	const companyPhone = useAppSelector(selectCompanyPhone)
	const isMobile = useMediaQuery("(max-width: 768px)")
	const { pathname } = useLocation()
	const showSettingsButton = pathname === "/" || pathname === "/feed"

	return (
		<div className={classes.info}>
			<ul className={classes.infoList}>
				{companyAddress && !isMobile && (
					<li>
						<div className={classes.infoItem}>
							<MapPinIcon width={19} height={19} />
							<Text size="sm" c="gray.3">
								{companyAddress}
							</Text>
						</div>
					</li>
				)}
				{companyPhone && (
					<li>
						{isMobile ? (
							<ContactModal subject="Заказать обратный звонок: Модальное окно - Шапка - Телефон - Мобильная версия">
								<Button variant="icon" p={0} bg="transparent">
									<PhoneIcon width={19} height={19} />
								</Button>
							</ContactModal>
						) : (
							<Anchor
								href={`tel:${companyPhone}`}
								leftSection={<PhoneIcon width={19} height={19} />}
								className={classes.infoLink}
							>
								<Text fw={600} style={{ textWrap: "nowrap" }}>
									{companyPhone}
								</Text>
							</Anchor>
						)}
					</li>
				)}
			</ul>
			{!isMobile ? (
				<ContactModal subject="Заказать обратный звонок: Модальное окно - Шапка - Кнопка - Десктопная версия">
					<Button className={classes.button} size="md" h={50}>
						<Text size="sm" fw={500}>
							Заказать обратный звонок
						</Text>
					</Button>
				</ContactModal>
			) : showSettingsButton ? (
				<SettingsButton onClick={openSidebar} isNormal={!isOpen} />
			) : null}
		</div>
	)
}
